$(document).ready(function() {

	let ACTION_TO_SECONDHAND_ITEMS_LISTING = "action-to-secondhand-items-listing";
	let SELECT_SECONDHAND_ITEM = "select-secondhand_item";
	let REASON_REJECT_MODAL = "#secondhand_reason_reject_modal";
	let SEND_REJECT_REASON = "#send-secondhand-reject-reason";
	let REASON_REJECT = "#secondhand-reason-reject";

	let URL_APPROVE_SECONDHAND_ITEMS = "/approve_secondhand_items";
	let URL_REJECT_SECONDHAND_ITEMS = "/reject_secondhand_items";

	function selectedSecondhandItemIds() {
		return $('.' + SELECT_SECONDHAND_ITEM + ':checkbox:checked').map(function() {
			return this.value;
		}).get().join(",");
	}

	$(document).on('click', '.' + ACTION_TO_SECONDHAND_ITEMS_LISTING, function() {
		let secondhand_items_ids = selectedSecondhandItemIds();
		if (secondhand_items_ids === "") {
			alert("Selecione ao menos 1 item");
			return;
		}
		if (this.id === "approve-secondhand-items") {
			approveSelectedSecondhandItems(secondhand_items_ids);
		} else if (this.id === "reject-secondhand-items") {
			$(REASON_REJECT_MODAL).modal('show');
			$(REASON_REJECT).focus();
		}
	});

	function approveSelectedSecondhandItems(secondhand_items_ids) {
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_APPROVE_SECONDHAND_ITEMS,
			method: 'POST',
			dataType: 'json',
			data: { secondhand_items_ids: secondhand_items_ids },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	}

	// Diferente da fila de anuncios, o motivo da reprovacao e obrigatorio.
	$(document).on('click', SEND_REJECT_REASON, function() {
		let secondhand_items_ids = selectedSecondhandItemIds();
		if (secondhand_items_ids === "") { return; }
		let motivo = $(REASON_REJECT).val();
		if ($.trim(motivo) === "") {
			alert("Informe o motivo da reprovação.");
			return;
		}
		if (!window.confirm("Você tem certeza?")) { return; }
		$.ajax({
			url: URL_REJECT_SECONDHAND_ITEMS,
			method: 'POST',
			dataType: 'json',
			data: { secondhand_items_ids: secondhand_items_ids, reject_reason: motivo },
			success: function(data) {
				alert(data.message);
				if (data.result) { window.location = window.location; }
			}
		});
	});

});
